// extracted by mini-css-extract-plugin
export default {"bottomSection":"BottomSection_bottomSection__744Vx","table":"BottomSection_table__HlXUa"};